export default "__VITE_ASSET__419fe8ec__"